import { queryOptions, useQuery } from '@tanstack/react-query';

import {
  getDynamicPageContent,
  getDynamicPagesList,
} from '@/components/app/dynamic-content/services';

import { GET_DYNAMIC_PAGE_CONTENT, GET_DYNAMIC_PAGES_LIST } from '@/constant/query-key';

export const getDynamicPagesListOptions = () => {
  return queryOptions({
    queryKey: [GET_DYNAMIC_PAGES_LIST],
    queryFn: () => getDynamicPagesList(),
  });
};

export function useGetDynamicPageContent(pageId: string) {
  return useQuery({
    queryKey: [GET_DYNAMIC_PAGE_CONTENT, pageId],
    queryFn: () => getDynamicPageContent(pageId),
    // enabled: false,
  });
}

export function getDynamicPageContentOptions(pageId: string) {
  return queryOptions({
    queryKey: [GET_DYNAMIC_PAGE_CONTENT, pageId],
    queryFn: () => getDynamicPageContent(pageId),
  });
}
